import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { store } from "../src/app/store";
import { AppRouter } from "./routers/AppRouter";

import "react-toastify/dist/ReactToastify.css";

function App() {
 
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Cache orders data for 30 minutes (much longer than default 5 minutes)
        cacheTime: 1000 * 60 * 30, // 30 minutes
        // Consider data fresh for 5 minutes (reduces unnecessary refetches)
        staleTime: 1000 * 60 * 5, // 5 minutes
        // Keep previous data while fetching new data
        keepPreviousData: true,
        // Retry failed requests
        retry: 2,
        // Refetch on window focus (good for getting latest orders)
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
